(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  // Optimized mega menu with preloaded product JSON
  document.addEventListener('DOMContentLoaded', () => {
    const collectionLinks = document.querySelectorAll('.mega-menu__category-link, .mega-menu__subcategory-link');

    // Helper to check if an image object or its properties indicate it is a lifestyle image
    function isLifestyle(imgObj) {
      if (!imgObj) return false;
      const alt = (imgObj.alt || '').toLowerCase();
      const src = (imgObj.src || '').toLowerCase();
      return alt.includes('lifestyle') || src.includes('lifestyle');
    }

    // Helper to get exactly 3 display items from a list of products/articles, prioritizing lifestyle images for products and showing blank slots for missing articles
    function getThreeDisplayItems(products) {
      if (!products || products.length === 0) {
        return [{ isEmpty: true }, { isEmpty: true }, { isEmpty: true }];
      }

      // Check if this is a list of blog articles
      if (products.length > 0 && products[0].is_article) {
        const items = [];
        if (products.length >= 3) {
          for (let i = 0; i < 3; i++) {
            const art = products[i];
            const img = (art.images && art.images.length > 0) ? art.images[0] : null;
            items.push({
              title: art.title,
              url: art.url || '#',
              imageUrl: img ? img.src : '',
              width: img ? (img.width || 500) : 500,
              height: img ? (img.height || 625) : 625,
              isEmpty: false
            });
          }
        } else if (products.length === 2) {
          items.push({ isEmpty: true });
          for (let i = 0; i < 2; i++) {
            const art = products[i];
            const img = (art.images && art.images.length > 0) ? art.images[0] : null;
            items.push({
              title: art.title,
              url: art.url || '#',
              imageUrl: img ? img.src : '',
              width: img ? (img.width || 500) : 500,
              height: img ? (img.height || 625) : 625,
              isEmpty: false
            });
          }
        } else if (products.length === 1) {
          items.push({ isEmpty: true });
          items.push({ isEmpty: true });
          const art = products[0];
          const img = (art.images && art.images.length > 0) ? art.images[0] : null;
          items.push({
            title: art.title,
            url: art.url || '#',
            imageUrl: img ? img.src : '',
            width: img ? (img.width || 500) : 500,
            height: img ? (img.height || 625) : 625,
            isEmpty: false
          });
        }
        return items;
      }
      
      const items = [];
      
      // Helper to get preferred image (lifestyle first, then first image)
      function getPreferredImage(product) {
        if (!product.images || product.images.length === 0) return null;
        const lifestyle = product.images.find(isLifestyle);
        return lifestyle || product.images[0];
      }

      if (products.length >= 3) {
        for (let i = 0; i < 3; i++) {
          const product = products[i];
          const preferred = getPreferredImage(product);
          items.push({
            title: product.title,
            url: product.url || (product.handle ? `/products/${product.handle}` : '#'),
            imageUrl: preferred ? preferred.src : '',
            width: preferred ? preferred.width : 500,
            height: preferred ? preferred.height : 500,
            isEmpty: false
          });
        }
      } else if (products.length === 2) {
        const p1 = products[0];
        const p2 = products[1];
        
        const p1Preferred = getPreferredImage(p1);
        const p2Preferred = getPreferredImage(p2);
        
        let fallbackImage = null;
        let fallbackProduct = null;
        
        // Step 1: Check p1 for another lifestyle image
        if (p1.images && p1.images.length > 1) {
          const otherLifestyle = p1.images.find(img => img.src !== (p1Preferred ? p1Preferred.src : '') && isLifestyle(img));
          if (otherLifestyle) {
            fallbackImage = otherLifestyle;
            fallbackProduct = p1;
          }
        }
        
        // Step 2: Check p2 for another lifestyle image
        if (!fallbackImage && p2.images && p2.images.length > 1) {
          const otherLifestyle = p2.images.find(img => img.src !== (p2Preferred ? p2Preferred.src : '') && isLifestyle(img));
          if (otherLifestyle) {
            fallbackImage = otherLifestyle;
            fallbackProduct = p2;
          }
        }
        
        // Step 3: Check p1 for any other image
        if (!fallbackImage && p1.images && p1.images.length > 1) {
          const other = p1.images.find(img => img.src !== (p1Preferred ? p1Preferred.src : ''));
          if (other) {
            fallbackImage = other;
            fallbackProduct = p1;
          }
        }
        
        // Step 4: Check p2 for any other image
        if (!fallbackImage && p2.images && p2.images.length > 1) {
          const other = p2.images.find(img => img.src !== (p2Preferred ? p2Preferred.src : ''));
          if (other) {
            fallbackImage = other;
            fallbackProduct = p2;
          }
        }
        
        // Step 5: Repetition fallback
        if (!fallbackImage) {
          fallbackImage = p1Preferred;
          fallbackProduct = p1;
        }
        
        items.push({
          title: p1.title,
          url: p1.url || (p1.handle ? `/products/${p1.handle}` : '#'),
          imageUrl: p1Preferred ? p1Preferred.src : '',
          width: p1Preferred ? p1Preferred.width : 500,
          height: p1Preferred ? p1Preferred.height : 500,
          isEmpty: false
        });
        
        items.push({
          title: p2.title,
          url: p2.url || (p2.handle ? `/products/${p2.handle}` : '#'),
          imageUrl: p2Preferred ? p2Preferred.src : '',
          width: p2Preferred ? p2Preferred.width : 500,
          height: p2Preferred ? p2Preferred.height : 500,
          isEmpty: false
        });
        
        items.push({
          title: fallbackProduct.title,
          url: fallbackProduct.url || (fallbackProduct.handle ? `/products/${fallbackProduct.handle}` : '#'),
          imageUrl: fallbackImage ? fallbackImage.src : '',
          width: fallbackImage ? fallbackImage.width : 500,
          height: fallbackImage ? fallbackImage.height : 500,
          isEmpty: false
        });
      } else if (products.length === 1) {
        const p1 = products[0];
        const p1Preferred = getPreferredImage(p1);
        
        let otherImage1 = null;
        let otherImage2 = null;
        
        if (p1.images && p1.images.length > 1) {
          // Collect other lifestyle images
          const otherLifestyles = p1.images.filter(img => img.src !== (p1Preferred ? p1Preferred.src : '') && isLifestyle(img));
          if (otherLifestyles.length > 0) otherImage1 = otherLifestyles[0];
          if (otherLifestyles.length > 1) otherImage2 = otherLifestyles[1];
          
          // Collect other non-lifestyle images
          const otherNonLifestyles = p1.images.filter(img => img.src !== (p1Preferred ? p1Preferred.src : '') && !isLifestyle(img));
          if (!otherImage1 && otherNonLifestyles.length > 0) {
            otherImage1 = otherNonLifestyles[0];
            if (otherNonLifestyles.length > 1) otherImage2 = otherNonLifestyles[1];
          } else if (!otherImage2 && otherNonLifestyles.length > 0) {
            const extra = otherNonLifestyles.find(img => img.src !== otherImage1.src);
            if (extra) otherImage2 = extra;
          }
        }
        
        if (!otherImage1) otherImage1 = p1Preferred;
        if (!otherImage2) otherImage2 = p1Preferred;
        
        items.push({
          title: p1.title,
          url: p1.url || (p1.handle ? `/products/${p1.handle}` : '#'),
          imageUrl: p1Preferred ? p1Preferred.src : '',
          width: p1Preferred ? p1Preferred.width : 500,
          height: p1Preferred ? p1Preferred.height : 500,
          isEmpty: false
        });
        items.push({
          title: p1.title,
          url: p1.url || (p1.handle ? `/products/${p1.handle}` : '#'),
          imageUrl: otherImage1 ? otherImage1.src : '',
          width: otherImage1 ? otherImage1.width : 500,
          height: otherImage1 ? otherImage1.height : 500,
          isEmpty: false
        });
        items.push({
          title: p1.title,
          url: p1.url || (p1.handle ? `/products/${p1.handle}` : '#'),
          imageUrl: otherImage2 ? otherImage2.src : '',
          width: otherImage2 ? otherImage2.width : 500,
          height: otherImage2 ? otherImage2.height : 500,
          isEmpty: false
        });
      }
      
      return items;
    }

    // Update product images using parsed JSON products/articles data
    function updateProductImages(container, products) {
      const displayItems = getThreeDisplayItems(products);
      
      container.innerHTML = displayItems.map(item => {
        if (item.isEmpty) {
          return `<div class="mega-menu__product mega-menu__product--empty" style="background: white; border: none;"></div>`;
        }
        const imageUrl = item.imageUrl || 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODAiIGhlaWdodD0iODAiIHZpZXdCb3g9IjAgMCA4MCA4MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjgwIiBoZWlnaHQ9IjgwIiBmaWxsPSIjRjVGNUY1Ii8+CjxwYXRoIGQ9Ik0zMiA0MEMzMiAzNS41ODIgMzUuNTgyIDMyIDQwIDMySDQwQzQ0LjQxOCAzMiA0OCAzNS41ODIgNDggNDBWNTRDNDggNTguNDE4IDQ0LjQxOCA2MiA0MCA2Mkg0MEMzNS41ODIgNjIgMzIgNTguNDE4IDMyIDU0VjQwWiIgZmlsbD0iI0NEQ0NEQyIvPgo8L3N2Zz4K';
        return `
          <a href="${item.url}" class="mega-menu__product" title="${item.title || 'View Article'}">
            <img src="${imageUrl}" alt="${item.title || 'Article Image'}" class="mega-menu__product-image" loading="eager" width="${item.width}" height="${item.height}">
            <div class="mega-menu__product-title">${item.title || 'Article'}</div>
          </a>
        `;
      }).join('');
    }

    // Handle hover to update mega menu products dynamically
    collectionLinks.forEach(link => {
      link.addEventListener('mouseenter', () => {
        let products = link._products;
        if (!products) {
          const productsJson = link.dataset.products;
          if (productsJson) {
            try {
              products = JSON.parse(productsJson);
              link._products = products;
            } catch (e) {
              console.error('Error parsing preloaded products JSON:', e);
            }
          }
        }
        
        const container = link.closest('.mega-menu__layout')?.querySelector('.mega-menu__products');
        if (container && products) {
          updateProductImages(container, products);
        }
      });
    });
  });

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
